export enum CURRENT_TAB_ID {
    KANBAN = 2,
    MATRIX = 3,
}
